import React, { Component } from "react";
import Navigation from "../screens/Navigation.jsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Headroom from "react-headroom";
import { ToastContainer, toast } from "react-toastify";
import io from "socket.io-client";
import axios from "axios"
import { Modal, Row } from "react-bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import TimeAgo from 'timeago-react'; // var TimeAgo = require('timeago-react');
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Markdownkatexnew from "./Markdown.js";
import { IoMdCreate, IoIosAlert, IoMdAlert, IoIosAddCircleOutline, IoIosAirplane } from "react-icons/io";
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
import { setLocalStorage, isAuth, } from "../helpers/auth.js";


export default class CreateNote extends Component {
	state = {
		showModal: false, title: "", detail: "", option: false, calification: "", curse: this.props.match.params.idcurse, likes: "", i: '', j: '', k: '', zz: [], id: "", files: "", submit: "Crear", editing: false, option: false,
	};

	open = () => this.setState({ showModal: true });
	close = () => this.setState({ showModal: false });

	getNotes = async () => {
		this.socket.emit('foroesfa', '69e5631506598f7ce9c31e21')
		this.socket.emit("temas", '69e5631506598f7ce9c31e21')
		this.socket.on("foro", (ww) => {
			console.log(ww, "new")
			this.setState({ zz: ww });
		})
	};

	componentWillUnmount() {
		this.socket.disconnect();
	}

	async componentDidMount() {
		// this.getNotes()
		document.title = `FORO ${process.env.REACT_APP_pagetitle}`
		this.socket = io(`${process.env.REACT_APP_URL}`)
		this.socket.emit('foroesfa', '69e5631506598f7ce9c31e21')
		this.socket.emit("temas", '69e5631506598f7ce9c31e21')
		this.socket.on("foro", (ww) => {
			this.setState({ zz: ww });
			console.log(ww, "new")
		})
	}

	///////////////////////////////////////////////////////////////////////////////////////////////
	CreateTheme = async () => {
		console.log(this.state.title, this.state.detail, isAuth()._id)
		await axios.post(`${process.env.REACT_APP_API_URL}/foros/theme`, {
			detail: this.state.detail,
			title: this.state.title,
			type: 'foroesfa',
			curse: '69e5631506598f7ce9c31e21',
			user: isAuth()._id
		})
			.then((res) => {
				this.getNotes()
				this.close()
			}).catch((error) => { console.log("ERROR", error.response) })
	};

	UpdateTheme = async () => {
		console.log(this.state.detail, this.state.title)
		await axios.put(`${process.env.REACT_APP_API_URL}/foros/theme/` + this.state.id, {
			detail: this.state.detail, title: this.state.title
		}).then(() => {
			this.getNotes()
			this.close()
			toast.dark("Tema actualizado correctamente")
		}).catch((error) => { console.log("ERROR", error.response) })
	};

	RemoveTheme = async (id) => {
		const response = window.confirm('Deseas eliminar este item?');
		if (response) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/foros/theme/` + id);
			this.getNotes();
			toast.dark('Removido correctamente');
		}
	};
	///////////////////////////////////////////////////////////////////////////////////////////////

	Likes = async (i) => {
		var data = this.state.zz ? this.state.zz : []
		console.log(data)
		if (data[i].likes === undefined || data[i].likes === null) { data[this.state.i].likes = [] }
		data[i].likes.unshift({ "user": isAuth().email, "likes": this.state.title, "unlikes": this.state.detail, "createdAt": new Date(), "updatedAt": new Date(), })
		this.setState({ zz: data, });
		this.Save(data)
	}

		UnLikes = async (i) => {
		var data = this.state.zz ? this.state.zz : []
		console.log(data)
		if (data[i].unlikes === undefined || data[i].unlikes === null) { data[this.state.i].unlikes = [] }
		data[i].unlikes.unshift({ "user": isAuth().email, "likes": this.state.title, "unlikes": this.state.detail, "createdAt": new Date(), "updatedAt": new Date(), })
		this.setState({ zz: data, });
		this.Save(data)
	}


	onInputChange = (e) => {
		//console.log(e.target.name, e.target.value);
		this.setState({ [e.target.name]: e.target.value })
	};

	Save = async (data) => {
		await axios.put(`${process.env.REACT_APP_API_URL}/foros/theme/` + this.state.id, data[this.state.i]).then(() => {
			// this.getNotes()
			this.close()
			toast.dark("Tema actualizado correctamente")
		}).catch((error) => { console.log("ERROR", error.response) })

	}

	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	CreateSubTheme = async () => {
		var data = this.state.zz ? this.state.zz : []
		console.log(data)
		if (data[this.state.i].units === undefined || data[this.state.i].units === null) {
			data[this.state.i].units = []
		}
		data[this.state.i].units.unshift({ "user": isAuth().email, "title": this.state.title, "detail": this.state.detail, "themes": [], "createdAt": new Date(), "updatedAt": new Date(), })
		this.setState({ zz: data, });
		this.Save(data)
	}

	updateSubTheme = async () => {
		var data = this.state.zz ? this.state.zz : []
		data[this.state.i].units[this.state.j].title = this.state.title
		data[this.state.i].units[this.state.j].detail = this.state.detail
		data[this.state.i].units[this.state.j].updatedAt = new Date()
		this.setState({ zz: data, });
		this.Save(data)
	}


	removeSubTheme = async (i, j) => {
		const response = window.confirm("Deseas eliminar este item?");
		if (response) {
			var data = this.state.zz ? this.state.zz : []
			data[i].units.splice(j, 1);
			console.log(data[i], "www")
			this.setState({ zz: data })
			this.Save(data)
		}
	}

	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////
	CreateSubSubTheme = async () => {
		var data = this.state.zz ? this.state.zz : []
		console.log(data)
		data[this.state.i].units[this.state.i].themes.unshift({ "user": isAuth().email, "title": this.state.title, "detail": this.state.detail, "themes": [], "createdAt": new Date(), "updatedAt": new Date(), })
		this.setState({ zz: data, });
		this.Save(data)
	}

	updateSubSubTheme = async () => {
		var data = this.state.zz ? this.state.zz : []
		data[this.state.i].units[this.state.j].themes[this.state.k].title = this.state.title
		data[this.state.i].units[this.state.j].themes[this.state.k].detail = this.state.detail
		data[this.state.i].units[this.state.j].themes[this.state.k].updatedAt = new Date()
		this.setState({ zz: data, });
		this.Save(data)
	}


	removeSubSubTheme = async (i, j, k) => {
		const response = window.confirm("Deseas eliminar este item?");
		if (response) {
			var data = this.state.zz ? this.state.zz : []
			data[i].units[j].themes.splice(k, 1);
			console.log(data[i], "www")
			this.setState({ zz: data })
			this.Save(data)
		}
	}
	///////////////////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////////////////





	render() {
		return (
			<>
				<ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />


				<Modal show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
					{/* <form onSubmit={this.state.i !== null ? this.CreateUnit : this.CreateTheme} > */}
					<div className="modal-header font-weight-bold"> {this.state.submit} </div>
					<div className="modal-body p-2">
						<input type="text" className="form-control my-1" placeholder="Título" onChange={this.onInputChange} name="title" value={this.state.title} />
						<CKEditor editor={ClassicEditor} config={{
							language: 'es',
							toolbar: ["math", "|", "undo", "redo", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "imageUpload", "blockQuote", "insertTable", "mediaEmbed", "heading"]
						}} data={this.state.detail} onChange={(event, editor) => {
							this.setState({
								detail: editor.getData()
							})
						}}
						/>
						{/* <DatePicker className="form-control mt-1 d-none" selected={this.state.fecha} onChange={this.onChangeDate} showTimeSelect dateFormat="MMMM d, yyyy h:mm aa" /> */}
					</div>
					<div className="modal-footer d-flex right-content-center">
						{/* <button className="btn btn-info"> {this.state.submit}</button> */}
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.updateSubSubTheme() }}> updateSubSubTheme </button>
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.CreateSubSubTheme() }}> CreateSubSubTheme </button>
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.updateSubTheme() }}> updateSubTheme </button>
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.CreateSubTheme() }}> CreateSubTheme </button>
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.UpdateTheme() }}> UpdateTheme </button>
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.CreateTheme() }}> CrearTheme </button>
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.close() }}> Close </button>
					</div>
					{/* </form> */}
				</Modal>

				<Headroom>
					<Navigation />
				</Headroom>

				<div className="container p-1 my-3">

					{isAuth() ?
						<button className="btn btn-info text-uppercase" onClick={() => { this.open(); this.setState({ option: true, title: '', detail: '' }) }} >
							Createtheme
						</button>
						: ''}

					{this.state.zz.map((note, i) => (
						<div className="container my-5 border border-warning rounded-lg p-1" key={i} >
							<div className="p-1 rounded-top">
								<div className="">
									<div className="pt-1 text-uppercase" style={{ 'fontWeight': "800" }}>
										<span className="">{note.title}</span>
									</div>
									<div className="text-secondary text-right border-bottom" style={{ fontSize: 12 }}>
										{note.usser[0].email}	<TimeAgo datetime={note.createdAt} locale='es_ES' /> <TimeAgo datetime={note.createdAt} locale='es_ES' />
									</div>
									<Markdownkatexnew>
										{note.detail}
									</Markdownkatexnew>
								</div>
								<button className="btn text-center" onClick={() => { this.Likes(i) }} >
									<IoMdAlert style={{ color: '#c99211ff', fontSize: '34px' }} />
								</button>
								<button className="btn text-center" onClick={() => { this.UnLikes(i) }} >
									<IoMdAlert style={{ color: '#b2d6efff', fontSize: '34px' }} />
								</button>

								<button className="btn btn-warning w-100" style={{ height: '11px', padding: '.1px' }} type="button" data-toggle="collapse" data-target={"#collapseOne" + note._id} aria-expanded="false">
								</button>
								<div className="input-group collapse" id={"collapseOne" + note._id}>
									<button className="btn text-center" onClick={() => { this.open(); this.setState({ option: true, title: '', detail: '', i: i, id: note._id }) }} >
										<IoMdAlert style={{ color: '#1c76b6ff', fontSize: '34px' }} />
									</button>
									<button className="btn text-center" onClick={() => { this.open(); this.setState({ option: true, title: note.title, detail: note.detail, i: i, id: note._id }) }} >
										<IoMdAlert style={{ color: '#062033ff', fontSize: '34px' }} />
									</button>
									<button className="btn text-center" onClick={() => { this.RemoveTheme(note._id) }}>
										<IoMdAlert style={{ color: '#bd3d79ff', fontSize: '34px' }} />
									</button>
								</div>
							</div>
							<div className="line pl-1">
								{note.units ? note.units.map((notte, j) => (
									<div className="p-1" key={j} >
										<div className="p-1 rounded-top">{notte.title}
										</div>
										<div className="text-secondary text-right border-bottom" style={{ fontSize: 12 }}>
											{notte.user} <TimeAgo datetime={notte.createdAt} locale='es_ES' /> <TimeAgo datetime={notte.createdAt} locale='es_ES' />
										</div>
										<Markdownkatexnew>
											{notte.detail}
										</Markdownkatexnew>
										<button className="btn btn-info w-100" style={{ height: '11px', padding: '.1px' }} type="button" data-toggle="collapse" data-target={"#collapseOne" + i + j} aria-expanded="false">
										</button>
										<div className="input-group collapse" id={"collapseOne" + i + j}>
											<button className="btn text-center" onClick={() => { this.open(); this.setState({ option: true, title: '', detail: '', i: i, j: j, id: note._id }) }} >
												<IoMdAlert style={{ color: '#98bcd7ff', fontSize: '34px' }} />
											</button>
											<button className="btn text-center" onClick={() => { this.open(); this.setState({ title: notte.title, detail: notte.detail, i: i, j: j, id: note._id }) }} >
												<IoMdAlert style={{ color: '#657f91ff', fontSize: '34px' }} />
											</button>
											<button className="btn text-center" onClick={() => { this.removeSubTheme(i, j); this.setState({ id: note._id }) }}>
												<IoMdAlert style={{ color: '#d67ba5ff', fontSize: '34px' }} />
											</button>
										</div>
										<div className="line pl-1">
											{notte.themes ? notte.themes.map((nottte, k) => (
												<div className="p-1" key={k} >
													<div className="p-1 rounded-top">{nottte.title}
													</div>
													<div className="text-secondary text-right border-bottom" style={{ fontSize: 12 }}>
														{nottte.user} <TimeAgo datetime={nottte.createdAt} locale='es_ES' /> <TimeAgo datetime={nottte.createdAt} locale='es_ES' />
													</div>
													<Markdownkatexnew>
														{nottte.detail}
													</Markdownkatexnew>
													<button className="btn btn-info w-100" style={{ height: '11px', padding: '.1px' }} type="button" data-toggle="collapse" data-target={"#collapseOne" + i + j + k} aria-expanded="false">
													</button>
													<div className="input-group collapse" id={"collapseOne" + i + j + k}>
														<button className="btn text-center" onClick={() => { this.open(); this.setState({ option: true, title: '', detail: '', i: i, id: note._id }) }} >
															<IoMdAlert style={{ color: '#d7d098ff', fontSize: '34px' }} />
														</button>
														<button className="btn text-center" onClick={() => { this.open(); this.setState({ title: nottte.title, detail: nottte.detail, i: i, j: j, k: k, id: note._id }) }} >
															<IoMdAlert style={{ color: '#d7d098ff', fontSize: '34px' }} />
														</button>
														<button className="btn text-center" onClick={() => { this.removeSubTheme(i, j, k); this.setState({ id: note._id }) }}>
															<IoMdAlert style={{ color: '#d7d098ff', fontSize: '34px' }} />
														</button>
													</div>
												</div>
											)) : ''}
										</div>
									</div>
								)) : ''}
							</div>
						</div>
					))}
				</div>
			</>
		);
	}
}
